export interface WatermarkOptions {
  useFullLogo?: boolean;
  position?: "center" | "top-right" | "bottom-right";
  opacity?: number;
  scale?: number;
  rotation?: number;
  quality?: number;
  pad?: number;
  logoUrl: string;
}

export const IMGIX_BASE = `${process.env.NEXT_PUBLIC_IMAGIX_URL}`;

export const FULL_LOGO_WITHOUT_TRADEMARK = `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ea1bc9bc-10f2-4ec6-a630-f208a6535f2f?fm=png`;
export const FULL_LOGO_WITH_TRADEMARK = `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/f8bc3d2d-e820-4bed-aceb-bd02a568a9d6?fm=png`;
export const LOGO_URL = FULL_LOGO_WITH_TRADEMARK || FULL_LOGO_WITHOUT_TRADEMARK;
export const FAVICON_URL = `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/fa4a3024-6d97-488b-88e0-a6f5d802b2ba?fm=png`;

export const PDF_WATERMARK: WatermarkOptions = {
  useFullLogo: true,
  opacity: 0.36,
  scale: 0.8,
  rotation: 45,
  quality: 100,
  pad: 0,
  logoUrl: LOGO_URL,
};
